<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('restaurantInfo') }}
      <template #subtitle>
        {{ $t('restaurantInfoSubtitle') }}
      </template>
      <template #action>
        <div class="d-flex align-center">
          <v-btn
            v-if="tab===0"
            color="black--text grey lighten-3"
            elevation="0"
            @click="dialog=!dialog"
          >
            <v-icon left>
              mdi-lock
            </v-icon>
            {{ $t('modifyRestaurantInfo') }}
          </v-btn>
          <v-btn
            v-if="tab===0 || tab===1 || tab ===2"
            class="ml-2 guide1End"
            color="amber lighten-4 black--text"
            elevation="0"
            @click="summit()"
          >
            <v-icon left>
              mdi-send
            </v-icon>
            {{ $t('save') }}
          </v-btn>
        </div>
      </template>
    </page-header>
    <div>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        show-arrows
        style="background: transparent"
      >
        <v-tab>
          {{ $t('BusinessInformation') }}
        </v-tab>
        <v-tab>
          {{ $t('StoreInformation') }}
        </v-tab>
        <v-tab>
          {{ $t('SoftwareSettings') }}
        </v-tab>
        <v-tab>
          {{ $t('ElectronicBill') }}
        </v-tab>
        <v-tab>
          {{ $t('PaymentSettings') }}
        </v-tab>
        <v-tab>
          {{ $t('openTime') }}
        </v-tab>
        <v-tab v-if="showItalyConfig === '1'">
          {{ $t('italySetting') }}
        </v-tab>
        <v-tab>
          奶茶机设置
        </v-tab>
      </v-tabs>
      <v-divider />
    </div>
    <v-tabs-items
      v-model="tab"
      style="background-color: transparent"
    >
      <v-tab-item>
        <div class="my-6">
          <div
            :style="$vuetify.breakpoint.xs ? 'grid-template-columns: 1fr;' : 'grid-template-columns: repeat(2,minmax(0,1fr));'"
            class="pb-4"
            style="display: grid;grid-gap: 32px;"
          >
            <div>
              <page-header>
                {{ $t('restaurantInfoAndSetting') }}
                <template #subtitle>
                  {{ $t('restaurantInfoAndSettingSubtitle') }}
                </template>
              </page-header>
              <div class="mt-4">
                <div class="text-overline">
                  {{ $t('name') }}
                </div>
                <v-text-field
                  v-model="editedItem.name"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('address') }}
                </div>
                <v-text-field
                  v-model="editedItem.adress1"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('adress2') }}
                </div>
                <v-text-field
                  v-model="editedItem.adress2"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('postCode') }}
                </div>
                <v-text-field
                  v-model="editedItem.postCode"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('city') }}
                </div>
                <v-text-field
                  v-model="editedItem.city"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('state') }}
                </div>
                <v-text-field
                  v-model="editedItem.state"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('taxNumber') }}
                </div>
                <v-text-field
                  v-model="editedItem.taxNumber"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('telephone') }}
                </div>
                <v-text-field
                  v-model="editedItem.telephone"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />

                <div class="text-overline mt-2">
                  {{ $t('BankCardNumber') }}
                </div>
                <v-text-field
                  v-model="editedItem.iban"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('BankIdentifierCode') }}
                </div>
                <v-text-field
                  v-model="editedItem.bic"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('BankAccountOwner') }}
                </div>
                <v-text-field
                  v-model="editedItem.kontoInhaber"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('BankName') }}
                </div>
                <v-text-field
                  v-model="editedItem.bankName"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />

                <div class="text-overline mt-2">
                  {{ $t('latitude') }}
                </div>
                <v-text-field
                  v-model="editedItem.latitude"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('longitude') }}
                </div>
                <v-text-field
                  v-model="editedItem.longitude"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
              </div>
            </div>
            <div>
              <page-header>
                {{ $t('legalPersonInformation') }}
                <template #subtitle>
                  {{ $t('legalPersonInformationSubtitle') }}
                </template>
              </page-header>
              <div class="mt-4">
                <div class="text-overline">
                  {{ $t('inhalterName') }}
                </div>
                <v-text-field
                  v-model="editedItem.inhalterName"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('inhalterLastName') }}
                </div>
                <v-text-field
                  v-model="editedItem.inhalterLastName"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('title') }}
                </div>
                <v-text-field
                  v-model="editedItem.inhalterTitle"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('emailAddress') }}
                </div>
                <v-text-field
                  v-model="editedItem.emailAddress"
                  :disabled="modifyRight"
                  dense
                  hide-details
                  outlined
                />
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div
          :style="$vuetify.breakpoint.mobile ? 'grid-template-columns: 1fr;' : 'grid-template-columns: 50% auto'"
          class="my-6"
          style="display: grid; grid-gap: 24px;"
        >
          <div>
            <page-header>
              {{ $t('LOGO') }}
              <template #subtitle>
                {{ $t('LOGOSubtitle') }}
              </template>
            </page-header>
            <v-card
              class="mt-4"
              elevation="0"
              outlined
            >
              <div class="pa-4">
                <div
                  style="display: grid; grid-gap: 32px; grid-template-columns: 1fr 1fr"
                >
                  <div>
                    <div class="text-subtitle-1">
                      {{ $t('orderPrintLogo') }}
                    </div>
                    <v-card
                      :height="$vuetify.breakpoint.mobile ? 150 : 200"
                      :width="$vuetify.breakpoint.mobile ? 150 : 200"
                      class="pa-2 mt-2"
                      color="#fafbfc"
                      elevation="0"
                      @click="bonLogoDialog=!bonLogoDialog"
                    >
                      <v-img
                        :src="bonLogo"
                        style="position:absolute;top: 8px;
                        left: 8px;right: 8px;bottom:8px;margin:auto"
                      />
                    </v-card>
                    <div class="mt-2 text-caption">
                      {{ $t('onlyUseBlackWhiteLogo') }}
                    </div>
                  </div>
                  <div class="d-block overflow-hidden">
                    <div class="text-subtitle-1 text-truncate">
                      {{ $t('restaurantLogo') }}
                    </div>
                    <v-card
                      :height="$vuetify.breakpoint.mobile ? 150 : 200"
                      :width="$vuetify.breakpoint.mobile ? 150 : 200"
                      class="pa-2"
                      color="#fafbfc"
                      elevation="0"
                      @click="buffetLogoDialog=!buffetLogoDialog"
                    >
                      <v-img
                        :src="buffetLogo"
                        style="position:absolute;top: 8px;
                        left: 8px;right: 8px;bottom:8px;margin:auto"
                      />
                    </v-card>
                    <div class="mt-2 text-caption d-flex flex-wrap">
                      <div>({{ $t('recommended_picture_size_512x512') }})</div>
                      <div>{{ $t('ToEditClick') }}</div>
                    </div>
                  </div>
                  <div>
                    <div class="text-subtitle-1">
                      {{ $t('storeQr') }}
                    </div>
                    <v-card
                      :height="$vuetify.breakpoint.mobile ? 150 : 200"
                      :width="$vuetify.breakpoint.mobile ? 150 : 200"
                      class="pa-2 mt-2"
                      color="#fafbfc"
                      elevation="0"
                    >
                      <qrcode-vue
                        :size="$vuetify.breakpoint.mobile ? 140 : 190"
                        :value="storeQRCode"
                        level="H"
                      />
                    </v-card>
                  </div>
                  <div class="d-block overflow-hidden">
                    <div class="text-subtitle-1 text-truncate">
                      预定顶部图片
                    </div>
                    <v-card
                      :height="$vuetify.breakpoint.mobile ? 150 : 200"
                      :width="$vuetify.breakpoint.mobile ? 150 : 200"
                      class="pa-2"
                      color="#fafbfc"
                      elevation="0"
                      @click="imageUrlDialog=!imageUrlDialog"
                    >
                      <v-img
                        :src="imageUrl"
                        style="position:absolute;top: 8px;
                        left: 8px;right: 8px;bottom:8px;margin:auto"
                      />
                    </v-card>
                    <div class="mt-2 text-caption d-flex flex-wrap">
                      <div>({{ $t('recommended_picture_size_512x512') }})</div>
                      <div>{{ $t('ToEditClick') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <v-dialog
                v-model="bonLogoDialog"
                max-width="300px"
              >
                <v-card class="pa-4">
                  <div class="text-h3">
                    {{ $t('editLogo') }}
                  </div>
                  <v-img
                    :src="bonLogo"
                    class="mt-4 "
                    width="100%"
                  />
                  <v-file-input
                    :label="$t('uploadTheImage')"
                    accept="image/*"
                    counter
                    prepend-icon="mdi-camera"
                    show-size
                    @change="processFile"
                  />
                  <v-btn
                    block
                    class="mt-4"
                    color="amber lighten-4 black--text"
                    dark
                    elevation="0"
                    @click="bonLogoSave"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-card-actions />
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="buffetLogoDialog"
                max-width="300px"
              >
                <v-card class="pa-4">
                  <div class="text-h3">
                    {{ $t('editLogo') }}
                  </div>
                  <v-img
                    :src="buffetLogo"
                    class="mt-4 "
                    width="100%"
                  />
                  <v-file-input
                    :label="$t('uploadTheImage')"
                    accept="image/*"
                    counter
                    prepend-icon="mdi-camera"
                    show-size
                    @change="processFileBuffet"
                  />
                  <v-btn
                    block
                    class="mt-4"
                    color="amber lighten-4 black--text"
                    dark
                    elevation="0"
                    @click="buffetLogoSave"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-card-actions />
                </v-card>
              </v-dialog>

              <v-dialog
                v-model="imageUrlDialog"
                max-width="300px"
              >
                <v-card class="pa-4">
                  <v-img
                    :src="imageUrl"
                    class="mt-4 "
                    width="100%"
                  />
                  <v-file-input
                    :label="$t('uploadTheImage')"
                    accept="image/*"
                    counter
                    prepend-icon="mdi-camera"
                    show-size
                    @change="processFileImageUrl"
                  />
                  <v-btn
                    block
                    class="mt-4"
                    color="amber lighten-4 black--text"
                    dark
                    elevation="0"
                    @click="reservationTitleImageSave"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-card-actions />
                </v-card>
              </v-dialog>
            </v-card>
          </div>
          <div>
            <page-header>
              {{ $t('restaurantIntroduce') }}
              <template #subtitle>
                {{ $t('restaurantIntroduceSubtitle') }}
              </template>
            </page-header>
            <v-card
              class="mt-4 pa-4"
              color="transparent"
              elevation="0"
            >
              <div>
                <div class="text-overline">
                  {{ $t('title') }}
                </div>
                <v-text-field
                  v-model="editedItem.buffetAnnouncementHead"
                  :placeholder="$t('Welcome')"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('ingredientIncludes') }}
                </div>
                <v-textarea
                  v-model="editedItem.buffetAnnouncementBody"
                  :placeholder="$t('Welcome')"
                  dense
                  height="150"
                  outlined
                />
              </div>
            </v-card>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="my-6">
          <div
            :style="$vuetify.breakpoint.xs ? 'grid-template-columns: 1fr;' : 'grid-template-columns: repeat(2,minmax(0,1fr));'"
            class="pb-4"
            style="display: grid;grid-gap: 32px;"
          >
            <div>
              <page-header>
                {{ $t('GeneralSoftwareSettings') }}
                <template #subtitle>
                  {{ $t('GeneralSoftwareSettingsSubtitle') }}
                </template>
              </page-header>

              <div class="mt-4">
                <div class="text-overline mt-2">
                  {{ $t('CardTerminalIp') }}
                </div>
                <v-text-field
                  v-model="editedItem.cardTerminalIp"
                  dense
                  hide-details
                  outlined
                />
                <div>
                  <div class="text-overline mt-2">
                    {{ $t('CardTerminalPort') }}
                  </div>
                  <v-text-field
                    v-model="editedItem.cardTerminalPort"
                    dense
                    hide-details
                    outlined
                  />
                </div>
                <div class="text-overline">
                  {{ $t('UseTaxModel') }}
                </div>
                <v-select
                  v-model="editedItem.taxExclusiveMode"
                  :items="trueOrFalse"
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  outlined
                />
                <div class="text-overline">
                  {{ $t('UseDailyNumbers') }}
                </div>
                <v-select
                  v-model="editedItem.useDailySerialAsQueueNumber"
                  :items="trueOrFalse"
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  outlined
                />
                <div class="text-overline">
                  {{ $t('StandardCyclePeriod') }}
                </div>
                <v-text-field
                  v-model="editedItem.dailySerialDisplayRotationFrom"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('StandardCyclePeriodEnd') }}
                </div>
                <v-text-field
                  v-model="editedItem.dailySerialDisplayRotationTo"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('tableColor') }}
                </div>
                <v-text-field
                  v-model="tableColorDisplay"
                  dense
                  hide-details
                  outlined
                >
                  <template
                    #append
                  >
                    <v-menu
                      v-model="tableColorMenu"
                      :close-on-content-click="false"
                      nudge-bottom="105"
                      nudge-left="16"
                      top
                    >
                      <template #activator="{ on }">
                        <div
                          :style="swatchStyle"
                          v-on="on"
                        />
                      </template>
                      <v-card>
                        <v-card-text
                          class="pa-0"
                        >
                          <v-color-picker
                            v-model="tableColorDisplay"
                            flat
                            mode="hsla"
                          />
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
                <div class="text-overline mt-2">
                  {{ $t('callColor') }}
                </div>
                <v-text-field
                  v-model="callColorDisplay"
                  dense
                  hide-details
                  outlined
                >
                  <template
                    #append
                  >
                    <v-menu
                      v-model="callColorMenu"
                      :close-on-content-click="false"
                      nudge-bottom="105"
                      nudge-left="16"
                      top
                    >
                      <template #activator="{ on }">
                        <div
                          :style="swatchStyleCall"
                          v-on="on"
                        />
                      </template>
                      <v-card>
                        <v-card-text
                          class="pa-0"
                        >
                          <v-color-picker
                            v-model="callColorDisplay"
                            flat
                            mode="hsla"
                          />
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </div>
            </div>
            <div>
              <page-header>
                {{ $t('PickUpAndDeliveryServiceSettings') }}
                <template #subtitle>
                  {{ $t('PickUpAndDeliveryManagementSubtitle') }}
                </template>
              </page-header>
              <div class="mt-4">
                <div class="text-overline">
                  {{ $t('PickUpAndDeliveryServiceToggleHint') }}
                </div>
                <v-select
                  v-model="editedItem.currentlyOpening"
                  :items="takeawayOption"
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  outlined
                />
                <div class="text-overline">
                  {{ $t('letterAhead') }}
                </div>
                <v-text-field
                  v-model="editedItem.letterOnExternalOrder"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('send_ZBon_to_email') }}
                </div>
                <v-text-field
                  v-model="editedItem.ZBonEmail"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline">
                  {{ $t('startPrice') }}
                </div>
                <v-text-field
                  v-model="editedItem.minimumDeliveryFee"
                  dense
                  hide-details
                  outlined
                />
                <div class="text-overline mt-2">
                  {{ $t('takeawayPriceModification') }}
                </div>
                <v-text-field
                  v-model="editedItem.takeawayPriceModification"
                  dense
                  hide-details
                  outlined
                />
              </div>
            </div>
            <!--            <div>-->
            <!--              <page-header>-->
            <!--                {{ $t('BuffetSettings') }}-->
            <!--                <template #subtitle>-->
            <!--                  {{ $t('BuffetSettingsSubtitle') }}-->
            <!--                </template>-->
            <!--              </page-header>-->
            <!--              <div class="mt-4">-->
            <!--                <div class="text-overline">-->
            <!--                  {{ $t('totalRound') }}-->
            <!--                </div>-->
            <!--                <v-text-field-->
            <!--                  v-model="editedItem.totalRound"-->
            <!--                  dense-->
            <!--                  hide-details-->
            <!--                  outlined-->
            <!--                />-->
            <!--                <div class="text-overline mt-2">-->
            <!--                  {{ $t('maxDineTime') }}-->
            <!--                </div>-->
            <!--                <v-text-field-->
            <!--                  v-model="editedItem.maxDineTime"-->
            <!--                  dense-->
            <!--                  hide-details-->
            <!--                  outlined-->
            <!--                />-->
            <!--                <div class="text-overline mt-2">-->
            <!--                  {{ $t('roundTime') }}-->
            <!--                </div>-->
            <!--                <v-text-field-->
            <!--                  v-model="editedItem.roundTime"-->

            <!--                  dense-->
            <!--                  hide-details-->
            <!--                  item-text="name"-->
            <!--                  item-value="id"-->
            <!--                  outlined-->
            <!--                />-->
            <!--                <div class="text-overline mt-2">-->
            <!--                  {{ $t('roundDishCount') }}-->
            <!--                </div>-->
            <!--                <v-text-field-->
            <!--                  v-model="editedItem.roundDishCount"-->
            <!--                  dense-->
            <!--                  hide-details-->
            <!--                  outlined-->
            <!--                />-->
            <!--                <div class="text-overline mt-2">-->
            <!--                  {{ $t('childRoundDishCount') }}-->
            <!--                </div>-->
            <!--                <v-text-field-->
            <!--                  v-model="editedItem.childRoundDishCount"-->
            <!--                  dense-->
            <!--                  hide-details-->
            <!--                  outlined-->
            <!--                />-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <electronic-billing />
      </v-tab-item>
      <v-tab-item>
        <payment-page />
      </v-tab-item>
      <v-tab-item>
        <open-time :purpose="''" />
      </v-tab-item>
      <v-tab-item v-if="showItalyConfig === '1'">
        <div class="my-6">
          <div class="mt-4">
            <ItalyConfig />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <milk-tea-setting />
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="dialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('obtainModificationPermission') }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="modifyPsw"
            :label="$t('inputPassword')"
            :messages="noteShow"
            type="password"
          />
          <v-btn
            block
            class="mt-4"
            color="amber lighten-4 black--text"
            elevation="0"
            @click="pswConfirm"
          >
            {{ $t('accessPermissions') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {
  freshReservationShopInfo,
  getNiceRestaurantInfo,
  reservationReady,
  updateRestaurantInfo
} from '@/model/dataLayer/service/otherService'
import GlobalConfig, { getRootUrl, Remember } from '@/model/global/GlobalSettings'
import hillo from 'hillo'
import PageHeader from '@/views/widget/typography/PageHeader'
import { showSuccessMessage, sureTo } from '@/model/utils/utils'
import i18n from '@/i18n'
import { updateOldSystemBackend, updateSystemBackend } from '@/model/dataLayer/service/RestaurantInfoService'
import OpenTime from '@/views/AadenPages/settings/OpenTime.vue'
import ElectronicBilling from '@/views/AadenPages/settings/ElectronicBilling'
import PaymentPage from '@/views/AadenPages/settings/PaymentPage'
import { mapMutations } from 'vuex'
import { editUserInfo, getReservationUserList } from '@/model/dataLayer/service/reservation/reservation'
import ItalyConfig from '@/views/AadenPages/settings/ItalyConfig.vue'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import { getShopQR } from '@/model/dataLayer/api/SaaS/user'
import QrcodeVue from 'qrcode.vue'
import MilkTeaSetting from '@/views/AadenPages/settings/MilkTeaSetting.vue'
import { ifReserveOpen } from '@/model/dataLayer/api/newReservation/reservation'
import { saveFiles } from '@/model/utils/reservationUtils'

const config = require('@/assets/config.json')

export default {
  components: { MilkTeaSetting, ItalyConfig, PaymentPage, ElectronicBilling, OpenTime, PageHeader, QrcodeVue },
  data: function () {
    return ({
      storeQRCode: '',
      showItalyConfig: '0',
      RememberList: Remember,
      realDeviceId: GlobalConfig.DeviceId,
      trueOrFalse: [
        {
          id: '0',
          name: i18n.t('no')
        },
        {
          id: '1',
          name: i18n.t('yes')
        }
      ],
      reservationInfo: null,
      restaurantVersion: Remember.restaurantVersion,
      tab: null,
      modifyPsw: '',
      dialog: null,
      bonLogoDialog: null,
      buffetLogoDialog: null,
      uploadBonLogoFile: null,
      uploadBuffetLogoFile: null,
      uploadImageUrlFile: null,
      imageUrlDialog: false,
      modifyRight: true,
      noteShow: '',
      statusList: [
        {
          id: '0',
          name: this.$i18n.t('yes')
        }, {
          id: '1',
          name: this.$i18n.t('no')
        }
      ],
      languageList: [
        {
          id: '0',
          name: this.$i18n.t('zh')
        }, {
          id: '1',
          name: this.$i18n.t('en')
        }, {
          id: '2',
          name: this.$i18n.t('de')
        }
      ],
      statusItem: {
        id: '',
        name: ''
      },
      langItem: {
        id: '',
        name: ''
      },
      loading: true,
      search: '',
      desserts: [],
      resinfo: {},
      editedIndex: -1,
      takeawayOption: [
        {
          id: '0',
          name: i18n.t('Close')
        },
        {
          id: '1',
          name: i18n.t('Open')
        }
      ],
      externalLetter: '',
      editedItem: {
        name: '',
        adress1: '',
        adress2: '',
        postCode: '',
        city: '',
        state: '',
        taxNumber: '',
        telephone: '',
        latitude: '',
        longitude: '',
        inhalterName: '',
        inhalterLastName: '',
        inhalterTitle: '',
        emailAddress: '',
        totalRound: '',
        maxDineTime: '',
        roundTime: '',
        roundDishCount: '',
        takeawayPriceModification: '',
        childRoundDishCount: '',
        tableColor: '',
        callColor: '',
        bonLogo: '',
        buffetLogo: '',
        currentlyOpening: '',
        letterOnExternalOrder: '',
        ZBonEmail: '',
        cardTerminalIp: ''
      },
      tableColorDisplay: '',
      tableColorMenu: false,
      callColorDisplay: '',
      callColorMenu: false,
      closeTakeAway: ['False', 'True'],
      RInfoAdvertisement: '',
      showStorageManagement: Remember.showStorageManagement === '1',

      reservationReady: false
    })
  },
  computed: {
    schemas () {
      return [
        {
          key: 'currencySymbols',
          name: 'useCurrencySymbols'
        }
      ]
    },
    bonLogo: function () {
      return this.editedItem.bonLogo
    },
    buffetLogo: function () {
      return this.editedItem.buffetLogo
    },
    imageUrl: function () {
      return this.editedItem.imageUrl
    },
    swatchStyle () {
      const {
        tableColorDisplay,
        tableColorMenu
      } = this
      return {
        backgroundColor: tableColorDisplay,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderStyle: 'solid',
        borderColor: '#c1c1c1',
        borderWidth: '1px',
        borderRadius: tableColorMenu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    swatchStyleCall () {
      const {
        callColorDisplay,
        callColorMenu
      } = this
      return {
        backgroundColor: callColorDisplay,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderStyle: 'solid',
        borderColor: '#c1c1c1',
        borderWidth: '1px',
        borderRadius: callColorMenu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },
  watch: {
    restaurantVersion (val) {
      Remember.restaurantVersion = val
      setTimeout(() => {
        location.reload()
      }, 500)
    },
    showStorageManagement (val) {
      Remember.showStorageManagement = val ? 1 : 0
      setTimeout(() => {
        location.reload()
      }, 500)
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },
  methods: {

    saveUserInfo (info) {
      Remember.currencySymbols = info.currencySymbols
      showSuccessMessage('SaveSuccess')
    },
    ...mapMutations(['showErrorDialog']),
    async updateBackend () {
      await sureTo(async () => {
        try {
          if (this.realDeviceId > 6000) {
            await updateSystemBackend()
          } else {
            await updateOldSystemBackend()
          }
          showSuccessMessage('UpdateSuccessfully')
        } catch (e) {
          this.showErrorDialog('FailToUpdateContactCustomerService')
        }
      }, 'UpdateContinuouslyYourBackend')
    },
    processFile (event) {
      console.log(event, 'event')
      this.uploadBonLogoFile = event
      this.editedItem.bonLogo = URL.createObjectURL(event)
    },

    processFileBuffet (event) {
      this.uploadBuffetLogoFile = event
      this.editedItem.buffetLogo = URL.createObjectURL(event)
    },

    processFileImageUrl (event) {
      this.uploadImageUrlFile = event
      this.editedItem.buffetLogo = URL.createObjectURL(event)
    },

    async reservationTitleImageSave () {
      this.editedItem.imageUrl = await saveFiles(this.uploadImageUrlFile)
      await updateRestaurantInfo(this.editedItem)
      await freshReservationShopInfo()
      if (this.reservationReady) {
        await editUserInfo(this.reservationInfo)
      }
      this.imageUrlDialog = false
    },

    async bonLogoSave () {
      await hillo.postWithUploadFile('Restaurant.php?op=changeBonLogo', {
        file: this.uploadBonLogoFile
      })
      this.bonLogoDialog = false
    },

    async buffetLogoSave () {
      await hillo.postWithUploadFile('Restaurant.php?op=changeBuffetLogo', {
        file: this.uploadBuffetLogoFile
      })
      if (this.reservationReady) {
        await editUserInfo(this.reservationInfo)
      }
      this.buffetLogoDialog = false
    },

    async initialize () {
      try {
        const res = await getShopQR(this.realDeviceId) ?? ''
        console.log(res, 'res')
        this.storeQRCode = res.bindingUUID
      } catch (e) {
        console.log(e, 'e')
      }
      this.showItalyConfig = await forceGetSystemSetting({
        section: 'aadenAdmin',
        sKey: 'useItalyBill',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.784',
        sOptions: '',
        tagList: 'basic'
      })
      this.reservationReady = await reservationReady()
      this.reservationInfo = (await getReservationUserList()).find(it => it.id === parseInt(this.realDeviceId))
      console.log(this.reservationInfo, 'reservationInfo')
      this.editedItem = await getNiceRestaurantInfo()

      // second and min exchange
      // this.editedItem = rundTimeSecondToMin(this.editedItem)
      for (const i of this.languageList) {
        if (i.name === this.$i18n.t(localStorage.getItem('lang'))) {
          this.langItem.id = i.id
        }
      }

      this.tableColorDisplay = this.editedItem.tableColor
      this.callColorDisplay = this.editedItem.callColor
      if (this.editedItem.bonLogo) {
        const tmpArr = this.editedItem.bonLogo.split('/../')
        this.editedItem.bonLogo = getRootUrl() + tmpArr[1]
      }

      if (this.editedItem.buffetLogo) {
        this.editedItem.buffetLogo = getRootUrl() + this.editedItem.buffetLogo
      }
    },
    async summit () {
      this.editedItem.tableColor = this.tableColorDisplay
      this.editedItem.callColor = this.callColorDisplay
      await sureTo(
        async () => {
          await updateRestaurantInfo(this.editedItem)
          const result = (await ifReserveOpen())
          if (result.code === 200 && result.data.userAvailable === false) {
            await editUserInfo({
              subDominName: result.data.userDominName.toLowerCase(),
              mapUrl: result.data.mapUrl
            })
          }
          showSuccessMessage(this.$t('SaveSuccess'))
          await this.initialize()
        },
        this.$i18n.t('RestaurantSelfConfig'))
    },
    selectStatus (i) {
      if (i === '0') {
        localStorage.setItem('isShowOnTable', '0')
      } else {
        localStorage.setItem('isShowOnTable', '1')
      }
      this.$router.go(0)
    },
    selectLangs (i) {
      this.$i18n.locale = config.supportLang[i].lang
      localStorage.setItem('lang', this.$i18n.locale)
      this.$router.go(0)
    },
    close () {
      this.dialog = false
      this.editedIndex = -1
    },
    pswConfirm () {
      if (this.modifyPsw === 'aaden1688') {
        this.modifyRight = false
        this.dialog = !this.dialog
        this.noteShow = ''
      } else {
        this.noteShow = i18n.t('PasswordWrong')
      }
    }
  }
}
</script>
